import OAuth from "./oauth"
import database from "./database"
import storage from "./storage"

export default {
  username: storage.fetch("username", ""),
  member: storage.fetch("member", {}),

  isAuthenticated() {
    return OAuth.isAuthenticated() || OAuth.shouldRefresh()
  },

  login(username, password) {
    return this.tryLogin(() => OAuth.passwordGrant(username, password))
  },

  refresh() {
    if (!this._refresh) {
      this._refresh = this
        .tryLogin(() => OAuth.refreshTokenGrant())
        .then(result => { this._refresh = null; return result })
    }
    return this._refresh
  },

  logout() {
    this.member = {}

    storage.clear()
    storage.set("username", this.username)

    database.delete()
    return OAuth.revokeAccessToken()
  },

  async tryLogin(callback) {
    const body = await callback()

    if (!body) {
      storage.clear()
      return false
    }

    this.member = body.member
    storage.set("member", this.member)
    storage.set("username", this.member.username)

    if (!database.isOpen()) {
      database.open()
    }

    return true
  },
}
